document.addEventListener("DOMContentLoaded", function() {
const marker = document.querySelector(".lily-question-override_TG");
if (marker) {
    const span = marker.parentElement.querySelector("a span");
    if (span) {
    // Original text, e.g. "12 Avaliações | 3 Perguntas"
    let text = span.textContent.trim();

    // Remove " | X Perguntas" part
    span.textContent = text.replace(/\s*\|\s*\d+\s*Perguntas?/, "");
    }
}
});



